import { injectable } from "inversify";
import { IApiResponse, IHttpService } from "../http-service";
import { rootContainer, TYPE } from "../container/root";
import { IAggregatorInfo, IDropOffSettings, IReturnLabelSettings, RETURN_METHOD_CATEGORY } from "../../pages/return-methods/return-method-types";
import { ICountry } from "./return-methods-service";
import { IMixPanelIdentity } from "../mixpanel.service";

interface IEligibleReturnMethodsResponse {
    eligible_return_methods: IEligibleReturnMethodCategory[],
    settings: IEligibleReturnMethodsResponseSettings,
}

interface IconvertRMsToSBRResponse {
    converted_return_methods: IEligibleReturnMethod[],
    failed_to_convert: IEligibleReturnMethod[],
}

export interface IEligibleReturnMethodsResponseSettings {
    wallet_promotions: IWalletPromotion[],
    is_wallet_activated: boolean,
    countries_list: ICountry[],
    aggregators_info: IAggregatorInfo[],
    identity: IMixPanelIdentity,
}

export interface IWalletPromotion {
    amount_usd: number,
    description: string,
    title: string,
    type: string,
}

export interface IEligibleReturnMethodCategory {
    category: RETURN_METHOD_CATEGORY, 
    list: IEligibleReturnMethod[],
}

export interface IEligibleReturnMethod {
    id: number,
    name: string,
    policy_rules_count: number,
    return_label_setting?: IReturnLabelSettings,
    drop_off_setting?: IDropOffSettings,
};

interface IShowSbrPromotionPage {
    show: boolean,
}

@injectable()
class ShipByReturnGoService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async getEligibleReturnMethods(): Promise<IEligibleReturnMethodsResponse> {
        const res = await this.httpService.get<IApiResponse<IEligibleReturnMethodsResponse>>(`/rms-api/ship-by-returngo/eligible-return-methods`);
        return res.payload;
    }

    async convertRMsToSBR(selectedReturnMethods: IEligibleReturnMethod[]): Promise<IconvertRMsToSBRResponse> {
        const res = await this.httpService.put<IApiResponse<IconvertRMsToSBRResponse>>(`/rms-api/ship-by-returngo/convert-rms-to-sbr`, selectedReturnMethods);
        return res.payload;
    }

    async getShowSbrPromotionPage(): Promise<IShowSbrPromotionPage> {
        const res = await this.httpService.get<IApiResponse<IShowSbrPromotionPage>>(`/rms-api/ship-by-returngo/show-sbr-promotion-page`);
        return res.payload;
    }
}

export default ShipByReturnGoService;